define('viewmodels/HeatMaps/InherentRiskHeatMap',['knockout', 'plugins/router', 'services/navigation', 'services/logger', 'durandal/system', 'services/appsecurity', 'durandal/app', 'services/utils', 'viewmodels/GeneralSettings'],
    function (ko, router, navigation, logger, system, appsecurity, app, utils, ObjGeneralSettings) {
        var title = 'Heat Map';

        var HmViewModel = {
            activate: activate,
            detached: detached,
            attached: attached,
            title: title,
            utils: utils,
            appsecurity: appsecurity,
            invokepage: invokepage,
            openSideNav: openSideNav,
            closeSideNav: closeSideNav,
            ObjGeneralSettings: ObjGeneralSettings,
            BUTitle: ko.observable('Business Unit'),
            IsSideNavOpen: ko.observable(0),
            AssessmentType: ko.observable(""),
            AmlInhHeatMapData: ko.observableArray(),
            AmlInhHeatMapDataDUP: ko.observableArray(),
            OverrideCommentsList: ko.observableArray(),
            BusinessLevelList: ko.observableArray(),
            ClickedBusinessLevelId: ko.observable(),
            ClickedBusinessLevelName: ko.observable(),
            BusinessLevelTabClick: BusinessLevelTabClick,
            NavigateToSSRSExportReport: NavigateToSSRSExportReport,
            SourceName: ko.observable("INH"),

            AssessmentTypeId: ko.observable(),
            BusinessLevel: ko.observable(),
            ScreenName: ko.observable(),
            InhRiskThemeDetails: ko.observableArray([]),
            InhRiskThemeDetailsDUP: ko.observableArray([]),
            AggregateBUDetails: ko.observableArray([]),
            riskType: ko.observable('I'),
            SelectedTaxonomyOption: ko.observable(),
            //filter feature
            NumberOfBUsSelected: ko.observable(),
            SelectedBUs: ko.observable(),
            ApplyBuFilters: ApplyBuFilters,
            FinalOrgFilterList: ko.observableArray([]),
            ClearAllBuFilters: ClearAllBuFilters,
            BusinessUnitListForFilters: ko.observableArray([]),
            BusinessUnitListForFiltersDUP: ko.observableArray([]),
            InitialBusinessUnitListForFilters: ko.observableArray([]),
            AggregateBUDetailsDUP: ko.observableArray([]),
            BUFiltersApplied: ko.observable(false),
            OrgLvlDrpDwnList: ko.observableArray(),
            OrgLvlValueList: ko.observableArray(),
            SelectedCheckedList: ko.observableArray([]),
            SelectedCheckedBUList: ko.observableArray([]),
            SubCheckboxSelected: SubCheckboxSelected,
            BusinessUnitListDUP: ko.observableArray([]),
            BusinessUnitList: ko.observableArray([]),
            ClickedRiskAreaType: ko.observable(),
            ClearOrgFilterSelection: ClearOrgFilterSelection,
            DistinctFileredBUs: ko.observableArray([]),
            ComposeBindingFlag: ko.observable(false),
            SubFactorGridDataList: ko.observableArray([]),
            TaxonomyLevelList: ko.observableArray([]),
            DataTableColumnWidth: ko.observable('&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;'),
            DisplayExportDropdown: DisplayExportDropdown,
            ShowFinalData: ko.observable(false),
            ColspanOrgLevel: ko.observable(3),
            ShowOrgLevelColumns: ko.observable(true),
            isAml: ko.observable(true),
            FormatValueDataLevel: FormatValueDataLevel,
            valuechangeLevel: valuechangeLevel,
            SelectedTaxonomyOptionText: ko.observable(''),
            BindDynamicLevels: BindDynamicLevels
        };
        function activate() {
            try {
                if (HmViewModel.ObjGeneralSettings === undefined || HmViewModel.ObjGeneralSettings.LocalizedTextList() === undefined || ((HmViewModel.ObjGeneralSettings.LocalizedTextList() !== undefined || HmViewModel.ObjGeneralSettings.LocalizedTextList() !== null) && HmViewModel.ObjGeneralSettings.LocalizedTextList().length === 0)) {
                    HmViewModel.ObjGeneralSettings.GetLocalizedData().then(function () {
                        HmViewModel.BUTitle((HmViewModel.ObjGeneralSettings.LocalizedTextList() == undefined || HmViewModel.ObjGeneralSettings.LocalizedTextList() == null || HmViewModel.ObjGeneralSettings.LocalizedTextList().length <= 0 || HmViewModel.ObjGeneralSettings.LocalizedIndexList() == undefined || HmViewModel.ObjGeneralSettings.LocalizedIndexList() == null || HmViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('BusinessUnits') == -1) ? 'Business Unit' : HmViewModel.ObjGeneralSettings.LocalizedTextList()[HmViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('BusinessUnits')].Name());
                    });
                }
                else
                    HmViewModel.BUTitle((HmViewModel.ObjGeneralSettings.LocalizedTextList() == undefined || HmViewModel.ObjGeneralSettings.LocalizedTextList() == null || HmViewModel.ObjGeneralSettings.LocalizedTextList().length <= 0 || HmViewModel.ObjGeneralSettings.LocalizedIndexList() == undefined || HmViewModel.ObjGeneralSettings.LocalizedIndexList() == null || HmViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('BusinessUnits') == -1) ? 'Business Unit' : HmViewModel.ObjGeneralSettings.LocalizedTextList()[HmViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('BusinessUnits')].Name());
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: activate() method in InherentRiskHeatMap.js';
                logger.logMessage(msg);
            }
        }


        function ClearOrgFilterSelection(data, event) {
            try {

                var selectedSubOrgLevelID = event.currentTarget.id.substr(event.currentTarget.id.indexOf("_") + 1);

                document.getElementById('DynamicOptedFilters_' + selectedSubOrgLevelID).innerHTML = "";

                $('.fa-check.' + selectedSubOrgLevelID).css({ 'display': 'none' });
                if (HmViewModel.SelectedCheckedList().length > 0) {
                    HmViewModel.SelectedCheckedList.remove(function (item) { return item.SubLevelId == selectedSubOrgLevelID });
                }

                //Logic to re-set the BU list
                HmViewModel.BusinessUnitListForFilters([]);
                if (HmViewModel.SelectedCheckedList().length > 0) {
                    var mappedBuList = $.map(HmViewModel.BusinessUnitListForFiltersDUP(), function (result) {
                        for (var m = 0; m < HmViewModel.SelectedCheckedList().length; m++) {
                            if (result.SubLevelId() == HmViewModel.SelectedCheckedList()[m].SubLevelId)
                                return new BusinessUnitModelDUP(result);
                        }
                    });
                    HmViewModel.BusinessUnitListForFilters(mappedBuList);
                    //Main tain this list to retain the org filters on deselection of applicability filters
                    HmViewModel.FinalOrgFilterList(mappedBuList);

                }
                else {
                    HmViewModel.BusinessUnitListForFilters([]);
                    var mappedBuList = $.map(HmViewModel.BusinessUnitListForFiltersDUP(), function (result) {
                        return new BusinessUnitModelDUP(result);
                    });
                    HmViewModel.BusinessUnitListForFilters(mappedBuList);
                    HmViewModel.FinalOrgFilterList(mappedBuList);
                    $('#BUFilterErrorHm').hide();
                }
                //Set count of BU's selected
                if (HmViewModel.BusinessUnitListForFilters().length > 0) {
                    HmViewModel.DistinctFileredBUs = ko.dependentObservable(function () {
                        var seen = [];
                        return HmViewModel.BusinessUnitListForFilters().filter(function (n) {
                            return seen.indexOf(n.BusinessUnitId()) == -1 && seen.push(n.BusinessUnitId());
                        });
                    });
                    HmViewModel.BusinessUnitListForFilters(HmViewModel.DistinctFileredBUs());
                }

                HmViewModel.NumberOfBUsSelected(HmViewModel.BusinessUnitListForFilters().length);
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ClearOrgFilterSelection() method in InherentRiskHeatMap.js';
                logger.logMessage(msg);
            }
        }


        function closeSideNav() {
            try {
                $('#BusinessUnitFilterBtnHm').removeClass("openFilter");
                document.getElementById("sideNavHm").style.top = "0";
                document.getElementById("sideNavHm").style.height = "0";
                document.getElementById("sideNavHm").style.borderTop = "unset";
                document.getElementById("sideNavHm").style.marginBottom = "0%";
                document.getElementById("sideNavHm").style.paddingBottom = "0%";
                $('#OrgFilterErrorHm').hide();
                $('#BUFilterErrorHm').hide();
                $('#loadingImgMainHm').modal('hide');
                HmViewModel.IsSideNavOpen(0);
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: closeSideNav() method in InherentRiskHeatMap.js';
                logger.logMessage(msg);
            }
        }


        function invokepage() {
            try {
                GetBusinessLevel();
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: invokepage() method in InherentRiskHeatMap.js';
                logger.logMessage(msg);
            }
        }


        function SubCheckboxSelected(data, event) {
            try {
                $('#OrgFilterErrorHm').hide();
                $('#BUFilterErrorHm').hide();
                var selectedSubOrgLevelID = event.currentTarget.id.substr(event.currentTarget.id.indexOf("el") + 2);
                var BUselected = "";
                if (isNaN(parseInt(selectedSubOrgLevelID)) && HmViewModel.SelectedCheckedList().length > 0) {
                    $('#BUFilterErrorHm').show();
                    return false;
                }
                else if (!isNaN(parseInt(selectedSubOrgLevelID)) && HmViewModel.SelectedCheckedBUList().length > 0) {
                    $('#OrgFilterErrorHm').show();
                    return false;
                }
                else if (!isNaN(parseInt(selectedSubOrgLevelID)) && HmViewModel.SelectedCheckedBUList().length == 0) {
                    for (var i = 0; i < HmViewModel.OrgLvlDrpDwnList().length; i++) {
                        var counterCheck = 0;
                        for (var g = 0; g < HmViewModel.OrgLvlDrpDwnList()[i].BusinessLevelValueList().length; g++) {
                            if (HmViewModel.OrgLvlDrpDwnList()[i].BusinessLevelValueList()[g].BlvalueId() == selectedSubOrgLevelID) {
                                if (event.currentTarget.checked) {
                                    $("#sublevel" + HmViewModel.OrgLvlDrpDwnList()[i].BusinessLevelValueList()[g].BlvalueId()).prop("checked", true);
                                    $('.fa-check.' + HmViewModel.OrgLvlDrpDwnList()[i].BusinessLevelValueList()[g].BlvalueId()).css({ 'display': 'inline-block' });

                                    HmViewModel.SelectedCheckedList.push({
                                        SubLevelId: HmViewModel.OrgLvlDrpDwnList()[i].BusinessLevelValueList()[g].BlvalueId(),
                                        SubLevelName: HmViewModel.OrgLvlDrpDwnList()[i].BusinessLevelValueList()[g].BlvalueName(),
                                        OrgLevelName: HmViewModel.OrgLvlDrpDwnList()[i].BlName()
                                    });
                                }
                                else {
                                    $("#sublevel" + HmViewModel.OrgLvlDrpDwnList()[i].BusinessLevelValueList()[g].BlvalueId()).prop("checked", false);
                                    $('.fa-check.' + HmViewModel.OrgLvlDrpDwnList()[i].BusinessLevelValueList()[g].BlvalueId()).css({ 'display': 'none' });
                                    if (HmViewModel.SelectedCheckedList().length > 0) {
                                        HmViewModel.SelectedCheckedList.remove(function (item) { return item.SubLevelId == HmViewModel.OrgLvlDrpDwnList()[i].BusinessLevelValueList()[g].BlvalueId() })
                                    }
                                }
                            }

                            //Mark parent check box as checked if all sub levels are selected
                            if ($("#sublevel" + HmViewModel.OrgLvlDrpDwnList()[i].BusinessLevelValueList()[g].BlvalueId()).prop('checked')) {
                                counterCheck++;
                            }
                            if (counterCheck > 0 && counterCheck == HmViewModel.OrgLvlDrpDwnList()[i].BusinessLevelValueList().length) {
                                $("#" + HmViewModel.OrgLvlDrpDwnList()[i].BlId()).prop("checked", true);
                            }
                            else if (counterCheck > 0 && counterCheck == HmViewModel.OrgLvlDrpDwnList()[i].BusinessLevelValueList().length) {
                                $("#" + HmViewModel.OrgLvlDrpDwnList()[i].BlId()).prop("checked", false);
                            }
                        }
                    }
                    //Logic to re-set the BU list
                    HmViewModel.BusinessUnitListForFilters([]);
                    if (HmViewModel.SelectedCheckedList().length > 0) {
                        var mappedBuList = $.map(HmViewModel.BusinessUnitListForFiltersDUP(), function (result) {
                            for (var m = 0; m < HmViewModel.SelectedCheckedList().length; m++) {
                                if (result.SubLevelId() == HmViewModel.SelectedCheckedList()[m].SubLevelId)
                                    return new BusinessUnitModelDUP(result);
                            }
                        });
                        HmViewModel.BusinessUnitListForFilters(mappedBuList);
                        //Main tain this list to retain the org filters on deselection of applicability filters
                        HmViewModel.FinalOrgFilterList(mappedBuList);

                    }
                    else {
                        HmViewModel.BusinessUnitListForFilters([]);
                        mappedBuList = $.map(HmViewModel.BusinessUnitListForFiltersDUP(), function (result) {
                            return new BusinessUnitModelDUP(result);
                        });
                        HmViewModel.BusinessUnitListForFilters(mappedBuList);
                        HmViewModel.FinalOrgFilterList(mappedBuList);
                    }
                    SetFilterSelection();

                } else if (isNaN(parseInt(selectedSubOrgLevelID)) && HmViewModel.SelectedCheckedList().length == 0) {
                    BUselected = event.currentTarget.id.substr(event.currentTarget.id.indexOf("BU") + 2);

                    for (var i = 0; i < HmViewModel.BusinessUnitListDUP().length; i++) {
                        if (HmViewModel.BusinessUnitListDUP()[i].BusinessUnitId() == BUselected) {
                            if (event.currentTarget.checked) {
                                $("#sublevelBU" + BUselected).prop("checked", true);
                                $('.fa-check.' + BUselected).css({ 'display': 'inline-block' });

                                HmViewModel.SelectedCheckedBUList.push({
                                    SubLevelId: HmViewModel.BusinessUnitListDUP()[i].BusinessUnitId(),
                                    SubLevelName: HmViewModel.BusinessUnitListDUP()[i].BusinessUnitName()
                                });
                            }
                            else {
                                $("#sublevelBU" + BUselected).prop("checked", false);
                                $('.fa-check.' + BUselected).css({ 'display': 'none' });
                                if (HmViewModel.SelectedCheckedBUList().length > 0) {
                                    HmViewModel.SelectedCheckedBUList.remove(function (item) { return item.SubLevelId == HmViewModel.BusinessUnitListDUP()[i].BusinessUnitId() })
                                }
                            }
                        }
                    }

                    if (HmViewModel.SelectedCheckedBUList().length > 0) {
                        //Logic to re-set the BU list
                        HmViewModel.BusinessUnitListForFilters([]);

                        var mappedBuList = $.map(HmViewModel.BusinessUnitListDUP(), function (result) {
                            for (var m = 0; m < HmViewModel.SelectedCheckedBUList().length; m++) {
                                if (result.BusinessUnitId() == HmViewModel.SelectedCheckedBUList()[m].SubLevelId)
                                    return new BusinessUnitModelDUP(result);
                            }
                        });
                        HmViewModel.BusinessUnitListForFilters(mappedBuList);
                    }
                    else {
                        HmViewModel.BusinessUnitListForFilters([]);
                        var mappedBuList = $.map(HmViewModel.BusinessUnitListForFiltersDUP(), function (result) {
                            return new BusinessUnitModelDUP(result);
                        });
                        HmViewModel.BusinessUnitListForFilters(mappedBuList);
                        HmViewModel.FinalOrgFilterList(mappedBuList);
                    }
                    SetBUFilterSelection();
                }
                //Set count of BU's selected
                if (HmViewModel.BusinessUnitListForFilters().length > 0) {
                    HmViewModel.DistinctFileredBUs = ko.dependentObservable(function () {
                        var seen = [];
                        return HmViewModel.BusinessUnitListForFilters().filter(function (n) {
                            return seen.indexOf(n.BusinessUnitId()) == -1 && seen.push(n.BusinessUnitId());
                        });
                    });
                    HmViewModel.BusinessUnitListForFilters(HmViewModel.DistinctFileredBUs());
                }

                HmViewModel.NumberOfBUsSelected(HmViewModel.BusinessUnitListForFilters().length)
            }
            catch (e) {
                var msg = 'Exception' + e + ' || source:  SubCheckboxSelected function in InherentRiskHeatMap.js';
                logger.logMessage(msg);
            }
        }

        function SetBUFilterSelection() {
            try {
                document.getElementById('DynamicOrgOptedFiltersHm').innerHTML = "";

                var contentHtml = "";
                for (var k = 0; k < HmViewModel.SelectedCheckedBUList().length; k++) {
                    contentHtml += '<div id="DynamicBUOptedFilters_' + HmViewModel.SelectedCheckedBUList()[k].SubLevelId + '" style="margin-right: 1rem;float: left;"><span style="font-size: 11px;background-color: white;font-weight: 600;border-radius: 10px; border: 1px solid #c5c3c3;"><span style="font-weight: 400; padding-left: 1rem;">BU </span> : ' + HmViewModel.SelectedCheckedBUList()[k].SubLevelName + '<button id="ClearFilterTextBU_' + HmViewModel.SelectedCheckedBUList()[k].SubLevelId + '" class="btn" style="font-weight:bold;background:transparent;margin-bottom:3px;" data-bind="click:ClearBUFilterSelection">x</button></span></div>';
                }

                document.getElementById('DynamicOrgOptedFiltersHm').innerHTML = contentHtml;
                for (var k = 0; k < HmViewModel.SelectedCheckedBUList().length; k++) {
                    ko.applyBindingsToNode($('#ClearFilterTextBU_' + HmViewModel.SelectedCheckedBUList()[k].SubLevelId), { click: HmViewModel.ClearBUFilterSelection }, HmViewModel);
                }
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: SetBUFilterSelection() method in InherentRiskHeatMap.js';
                logger.logMessage(msg);
            }
        }

        function SetFilterSelection() {
            try {
                document.getElementById('DynamicOrgOptedFiltersHm').innerHTML = "";
                //Mark Org levels filter seletion
                var contentHtml = "";
                for (var k = 0; k < HmViewModel.SelectedCheckedList().length; k++) {
                    contentHtml += '<div id="DynamicOptedFilters_' + HmViewModel.SelectedCheckedList()[k].SubLevelId + '" style="margin-right: 1rem;float: left;"><span style="font-size: 11px;background-color: white;font-weight: 600;border-radius: 10px; border: 1px solid #c5c3c3;"><span style="font-weight: 400; padding-left: 1rem;">' + HmViewModel.SelectedCheckedList()[k].OrgLevelName + '</span> : ' + HmViewModel.SelectedCheckedList()[k].SubLevelName + '<button id="ClearFilterText_' + HmViewModel.SelectedCheckedList()[k].SubLevelId + '" class="btn" style="font-weight:bold;background:transparent;margin-bottom:3px;" data-bind="click:ClearOrgFilterSelection">x</button></span></div>';
                }
                document.getElementById('DynamicOrgOptedFiltersHm').innerHTML = contentHtml;
                for (var k = 0; k < HmViewModel.SelectedCheckedList().length; k++) {
                    ko.applyBindingsToNode($('#ClearFilterText_' + HmViewModel.SelectedCheckedList()[k].SubLevelId), { click: HmViewModel.ClearOrgFilterSelection }, HmViewModel);
                }
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ClearOrgFilterSelection() method in InherentRiskHeatMap.js';
                logger.logMessage(msg);
            }
        }

        function attached() {
            try {

                var Id = HmViewModel.appsecurity.getParameterByName('atype');
                HmViewModel.AssessmentTypeId(Id);
                HmViewModel.appsecurity.GetAssessmentNames().then(function () {
                    HmViewModel.AssessmentType(HmViewModel.appsecurity.GetAssessmentName(HmViewModel.AssessmentTypeId()))
                    HmViewModel.ScreenName(HmViewModel.AssessmentType() + ' Overall Inherent Risk Heatmap');
                })
                var parent = $(location).attr('href').split('/').pop();
                $('#expheatmapHm').show();
                if (parent.split('?')[0] == 'InherentRiskHeatMap') {
                    HmViewModel.ComposeBindingFlag(false);
                    invokepage();
                }
                else {
                    $("#BusinessUnitFilterBtnHm").hide();
                    $("#expheatmapHm").hide();
                    $("#myDropdownSort").hide();
                    HmViewModel.ComposeBindingFlag(true);
                    $("#MainInherentHeatMapDiv").css({ 'overflow-y': 'scroll', 'height': '50vh' });
                }
                HmViewModel.SelectedCheckedBUList([]);
                HmViewModel.SelectedCheckedList([]);
                HmViewModel.SelectedBUs('');
                closeSideNav();
                HmViewModel.BUFiltersApplied(false);
                HmViewModel.NumberOfBUsSelected(0);
                $('.badge').css({ 'display': 'none' });

                GetTaxonomyList();
                HmViewModel.SelectedTaxonomyOption(null);
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: attached() method in InherentRiskHeatMap.js';
                logger.logMessage(msg);
            }
        }
        return HmViewModel;

        function sortResetDefault(data, event) {
            try {
                $('.fa-check.1').css({ 'display': 'none' });
                $('.fa-check.2').css({ 'display': 'none' });
                $('.fa-check.3').css({ 'display': 'none' });
                $('.fa-check.4').css({ 'display': 'none' });
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: sortResetDefault() method in InherentRiskHeatMap.js';
                logger.logMessage(msg);
            }
        }

        function BindHTML() {
            try {
                //Org Level Filter Fossil style
                var OrgList = "";

                OrgList += '<div class="mt-1">' +
                    '<ul class="pb-2 nav nav-tabs">';

                for (var i = 0; i < HmViewModel.OrgLvlDrpDwnList().length; i++) {
                    if (i == 0) {
                        OrgList += '<li class="p-1"><a href="#tab_' + HmViewModel.OrgLvlDrpDwnList()[i].BlId() + '" data-toggle="tab" class="active">' + HmViewModel.OrgLvlDrpDwnList()[i].BlName() + '<i class="ml-2 fa fa-chevron-down" aria-hidden="true"></i> </a></li>'
                    } else {
                        OrgList += '<li class="p-1"><a href="#tab_' + HmViewModel.OrgLvlDrpDwnList()[i].BlId() + '" data-toggle="tab">' + HmViewModel.OrgLvlDrpDwnList()[i].BlName() + '<i class="ml-2 fa fa-chevron-down" aria-hidden="true"></i> </a></li>'
                    }
                }
                OrgList += '<li class="p-1"><a href="#tab_BU" data-toggle="tab">' + HmViewModel.BUTitle() +' <i class="ml-2 fa fa-chevron-down" aria-hidden="true"></i> </a></li>'

                OrgList += '</ul>' +
                    '<div class="tab-content" style="height: 12vh;overflow-y: auto;">';

                for (var i = 0; i < HmViewModel.OrgLvlDrpDwnList().length; i++) {
                    if (i == 0) {
                        OrgList += '<div class="tab-pane active" id="tab_' + HmViewModel.OrgLvlDrpDwnList()[i].BlId() + '">'
                    } else {
                        OrgList += '<div class="tab-pane" id="tab_' + HmViewModel.OrgLvlDrpDwnList()[i].BlId() + '">'
                    }

                    if (HmViewModel.OrgLvlDrpDwnList()[i].BusinessLevelValueList().length > 0) {

                        for (var j = 0; j < HmViewModel.OrgLvlDrpDwnList()[i].BusinessLevelValueList().length; j++) {
                            OrgList += '<label class="mt-2 mr-3 cursor-pointer">' +
                                '<input id=sublevel' + HmViewModel.OrgLvlDrpDwnList()[i].BusinessLevelValueList()[j].BlvalueId() + ' type="checkbox" data-bind="event:{change:$root.SubCheckboxSelected}" style="font-weight: 600;position : fixed;clip : rect(0,0,0,0);pointer-events : none;">' +
                                '<i class="mr-1 fa fa-check ' + HmViewModel.OrgLvlDrpDwnList()[i].BusinessLevelValueList()[j].BlvalueId() + '" aria-hidden="true" style="display:none"></i>' +
                                '<span class="cc-facet-result-text tag-text">' + HmViewModel.OrgLvlDrpDwnList()[i].BusinessLevelValueList()[j].BlvalueName() + '</span>' +
                                '</label>';
                        }

                    }
                    OrgList += '</div>';
                }
                OrgList += '<div class="tab-pane" id="tab_BU">';

                HmViewModel.DistinctFileredBUs = ko.dependentObservable(function () {
                    var seen = [];
                    return HmViewModel.BusinessUnitListForFilters().filter(function (n) {
                        return seen.indexOf(n.BusinessUnitId()) == -1 && seen.push(n.BusinessUnitId());
                    });
                });

                HmViewModel.BusinessUnitListForFilters(HmViewModel.DistinctFileredBUs());

                for (var w = 0; w < HmViewModel.BusinessUnitListForFilters().length; w++) {
                    OrgList += '<label class="mt-2 mr-3  cursor-pointer">' +
                        '<input id=sublevelBU' + HmViewModel.BusinessUnitListForFilters()[w].BusinessUnitId() + ' type="checkbox" data-bind="event:{change:$root.SubCheckboxSelected}" style="font-weight: 600;position : fixed;clip : rect(0,0,0,0);pointer-events : none;">' +
                        '<i class="mr-1 fa fa-check ' + HmViewModel.BusinessUnitListForFilters()[w].BusinessUnitId() + '" aria-hidden="true" style="display:none"></i>' +
                        '<span class="cc-facet-result-text tag-text">' + HmViewModel.BusinessUnitListForFilters()[w].BusinessUnitName() + '</span>' +
                        '</label>';
                }
                OrgList += '</div>';

                if (OrgList == "") {
                    OrgList = '<div id="NoorganizationalLevelerror" class="alert-warning"><label class="control-label">Organizational Levels are not configured for this Year of Assessment.</label></div>';

                }
                document.getElementById('OrganizationalLevelHm').innerHTML = OrgList;

                for (var i = 0; i < HmViewModel.OrgLvlDrpDwnList().length; i++) {
                    for (var l = 0; l < HmViewModel.OrgLvlDrpDwnList()[i].BusinessLevelValueList().length; l++) {
                        ko.applyBindingsToNode($('#sublevel' + HmViewModel.OrgLvlDrpDwnList()[i].BusinessLevelValueList()[l].BlvalueId()), { event: { change: HmViewModel.SubCheckboxSelected } }, HmViewModel);
                    }
                }

                for (var k = 0; k < HmViewModel.BusinessUnitListForFilters().length; k++) {
                    ko.applyBindingsToNode($('#sublevelBU' + HmViewModel.BusinessUnitListForFilters()[k].BusinessUnitId()), { event: { change: HmViewModel.SubCheckboxSelected } }, HmViewModel);
                }
                $('#loadingImgMainHm').modal('hide');
                HmViewModel.NumberOfBUsSelected(HmViewModel.BusinessUnitListForFilters().length);
            }
            catch (e) {
                var msg = 'Exception' + e + ' || source:BindHTML function in InherentRiskHeatMap.js';
                logger.logMessage(msg);
            }
        }


        function GetAllOrganizationalLevels() {
            try {
                return $.ajax({
                    url: "/api/Configuration/getDistinctBusinessLevelsAllBUApplicability",
                    type: "GET",
                    headers: appsecurity.getSecurityHeaders(),
                    data: { TypeId: HmViewModel.AssessmentTypeId(), YOA: null }
                })
                    .success(ajaxSuccess)
                    .fail(ajaxFail)
            }

            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ajax caLL in GetAllOrganizationalLevels() in InherentRiskHeatMap.js';
                logger.logMessage(msg);

            }

            function ajaxSuccess(jsonResult, status) {
                try {
                    if (jsonResult != null) {
                        var OrganizationalLevels = $.map(jsonResult, function (result) {
                            return new BusinessLevelsModel(result);
                        });
                        if (OrganizationalLevels.length > 0) {
                            HmViewModel.OrgLvlDrpDwnList(OrganizationalLevels);
                            HmViewModel.OrgLvlValueList(HmViewModel.OrgLvlDrpDwnList()[0].BusinessLevelValueList());
                        }
                        //Get all BU list with org sub level id's
                        GetAllBusinessUnitsForFilters();
                        HmViewModel.SelectedCheckedList([]);
                        HmViewModel.SelectedCheckedBUList([]);
                        document.getElementById('DynamicOrgOptedFiltersHm').innerHTML = "";
                    }
                    else
                        logger.logError('An error occurred. Please contact your Application Administrator.', 'Error', system.getModuleId(HmViewModel), true);
                }
                catch (e) {
                    var msg = 'Exception: ' + e + ' | Source: ajaxSuccess in GetAllOrganizationalLevels() in InherentRiskHeatMap.js';
                    logger.logMessage(msg);
                }
            }

            function ajaxFail(error, status) {
                try {
                    if (error.status == 401) {
                        app.showMessage("You have been logged out. Please login again to complete the operation.", "Error in Edit Operation", ["OK"], false, { buttonClass: "fa fa-times btn btn-default", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
                            .then(function (option) {
                                if (option == "OK")
                                    navigation.unauthorized();
                            })
                    }
                    else {
                        var msg = 'Exception: ' + error.statusText + ' | Source: ajaxFail in GetAllOrganizationalLevels() method in InherentRiskHeatMap.js';
                        logger.logMessage(msg);
                    }
                }
                catch (e) {
                    var msg = 'Exception: ' + e + ' | Source: ajaxFail in GetAllOrganizationalLevels() method in InherentRiskHeatMap.js';
                    logger.logMessage(msg);
                }
            }
        }

        function BuLevelValueListModel(item) {
            try {
                var self = this;
                self.BlvalueId = ko.observable($('<div/>').html(item.BlvalueId).text());
                self.BlvalueName = ko.observable($('<div/>').html(item.BlvalueName).text());
                self.ParentBuLevel = ko.observable($('<div/>').html(item.ParentBuLevel).text());
                self.BlvalueShortName = ko.observable($('<div/>').html(item.BlvalueShortName).text());
                self.TargetRow = ko.observable(item.TargetRow);
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: BuLevelValueListModel() method in InherentRiskHeatMap.js';
                logger.logMessage(msg);
            }
        }

        function GetAllBusinessUnitsForFilters() {
            try {

                return $.ajax({
                    url: "/api/AMLRiskAssessment/GetAllBusinessUnitsForFiltersBUApplicability",
                    type: "GET",
                    headers: appsecurity.getSecurityHeaders(),
                    data: { TypeId: HmViewModel.AssessmentTypeId() }
                })
                    .success(ajaxSuccess)
                    .fail(ajaxFail)
            }

            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ajax caLL in GetAllBusinessUnitsForFilters() in InherentRiskHeatMap.js';
                logger.logMessage(msg);

            }

            function ajaxSuccess(jsonResult, status) {
                try {
                    if (jsonResult != null) {
                        var mappedBuList = $.map(jsonResult, function (result) {
                            return new BusinessUnitModel(result);
                        });
                        HmViewModel.BusinessUnitListForFilters(mappedBuList);
                        HmViewModel.BusinessUnitListForFiltersDUP(mappedBuList);

                        HmViewModel.BusinessUnitListDUP = ko.dependentObservable(function () {
                            var seen = [];
                            return mappedBuList.filter(function (n) {
                                return seen.indexOf(n.BusinessUnitId()) == -1 && seen.push(n.BusinessUnitId());
                            });
                        });
                        BindHTML();
                        $('#OrgFilterErrorHm').hide();
                        $('#BUFilterErrorHm').hide();
                        document.getElementById("sideNavHm").style.top = "unset";
                        document.getElementById("sideNavHm").style.height = "33vh";
                    }
                    else
                        logger.logError('An error occurred. Please contact your Application Administrator.', 'Error', system.getModuleId(HmViewModel), true);
                }
                catch (e) {
                    var msg = 'Exception: ' + e + ' | Source: ajaxSuccess in GetAllBusinessUnitsForFilters() in InherentRiskHeatMap.js';
                    logger.logMessage(msg);
                }
            }

            function ajaxFail(error, status) {
                try {
                    if (error.status == 401) {
                        app.showMessage("You have been logged out. Please login again to complete the operation.", "Error in Edit Operation", ["OK"], false, { buttonClass: "fa fa-times btn btn-default", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
                            .then(function (option) {
                                if (option == "OK")
                                    navigation.unauthorized();
                            })
                    }
                    else {
                        var msg = 'Exception: ' + error.statusText + ' | Source: ajaxFail in GetAllBusinessUnitsForFilters() method in InherentRiskHeatMap.js';
                        logger.logMessage(msg);
                    }
                }
                catch (e) {
                    var msg = 'Exception: ' + e + ' | Source: ajaxFail in GetAllBusinessUnitsForFilters() method in InherentRiskHeatMap.js';
                    logger.logMessage(msg);
                }
            }
        }

        //Apply filter event
        function ApplyBuFilters(data, event) {
            try {
                HmViewModel.SelectedBUs('');
                var SelectedBUsString = "";
                for (var i = 0; i < data.BusinessUnitListForFilters().length; i++) {
                    if (SelectedBUsString === "")
                        SelectedBUsString = data.BusinessUnitListForFilters()[i].BU_ID().toString();
                    else
                        SelectedBUsString += "," + data.BusinessUnitListForFilters()[i].BU_ID().toString();
                }
                closeSideNav();
                HmViewModel.SelectedBUs(SelectedBUsString);
                getHeatMapData();
                HmViewModel.BUFiltersApplied(true);
                HmViewModel.NumberOfBUsSelected(data.BusinessUnitListForFilters().length);
                $('.badge').css({ 'display': 'inline-block' });
                sortResetDefault();
                $('#myDropdown').removeClass('show');
                $('#myDropdownSort').removeClass('open');
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ApplyBuFilters() method in InherentRiskHeatMap.js';
                logger.logMessage(msg);
            }
        }

        //clear filter event
        function ClearAllBuFilters(data, event) {
            try {
                HmViewModel.BusinessUnitList(HmViewModel.BusinessUnitListDUP());
                HmViewModel.SelectedCheckedBUList([]);
                HmViewModel.SelectedCheckedList([]);
                HmViewModel.SelectedBUs('');
                closeSideNav();
                HmViewModel.BUFiltersApplied(false);
                HmViewModel.NumberOfBUsSelected(0);
                $('.badge').css({ 'display': 'none' });
                getHeatMapData();
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ClearAllBuFilters() method in InherentRiskHeatMap.js';
                logger.logMessage(msg);
            }
        }

        function openSideNav() {
            try {
                $('#myValueDropdown').removeClass('show');
                $('#myValueDropdownSort').removeClass('open');
                $('#myDropdown').removeClass('show');
                $('#myDropdownSort').removeClass('open');
                $('#exportDropdownHm').removeClass('show');
                $('#exportDropdownBtnHm').removeClass('open');
                $('#myValueDropdownLevel').removeClass('show');
                $('#myValueDropdownSortLevel').removeClass('open');


                if ($('#BusinessUnitFilterBtnHm').hasClass("openFilter")) {
                    closeSideNav();
                } else {
                    $('#BusinessUnitFilterBtnHm').addClass("openFilter");
                    $('#OrgFilterErrorHm').hide();
                    $('#BUFilterErrorHm').hide();
                    if (HmViewModel.BUFiltersApplied() == false) {
                        $('#loadingImgMainHm').modal('show');
                        GetAllOrganizationalLevels();
                    }
                    else {
                        document.getElementById("sideNavHm").style.top = "unset";
                        document.getElementById("sideNavHm").style.height = "33vh";
                    }
                }
                HmViewModel.IsSideNavOpen(1);
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: openSideNav() method in InherentRiskHeatMap.js';
                logger.logMessage(msg);
            }
        }

        function GetBusinessLevel() {
            try {
                return $.ajax({
                    url: "/api/Configuration/getAllBusinessUnitLevels?type=" + HmViewModel.AssessmentTypeId() + "&Page_Type=IH",
                    type: "GET",
                    headers: appsecurity.getSecurityHeaders()
                })
                    .success(ajaxSuccess)
                    .fail(ajaxFail)
            } catch (e) {

                var msg = 'Exception: ' + e + ' | Source: ajax call in GetBusinessLevel() method in InherentRiskHeatMap.js';
                logger.logMessage(msg);
            }
            function ajaxSuccess(jsonResult, status) {
                try {
                    if (jsonResult != null) {
                        HmViewModel.BusinessLevel(jsonResult.length);
                        var MappedBUModelList = $.map(jsonResult, function (result) {
                            var BusinessLevelModelObj = new BusinessLevelModel(result);
                            return BusinessLevelModelObj;
                        });

                        HmViewModel.BusinessLevelList(MappedBUModelList);
                        $('#RaHeatmapTabAML').tabs();
                        $('#RaHeatmapTabAML').tabs('refresh');
                        $('#RaHeatmapTabAML').tabs({ active: 0 });
                        $($('#RiskAreaHeatmapAMLUl li').get(0)).trigger('click');
                        scrollableTabs();
                    }
                    else
                        logger.logError('An error occurred. Please contact your Application Administrator.', 'Error', system.getModuleId(HmViewModel), true);
                }
                catch (e) {
                    var msg = 'Exception: ' + e + ' | Source: ajaxSuccess call in GetBusinessLevel() method in InherentRiskHeatMap.js';
                    logger.logMessage(msg);
                }
            }
            function ajaxFail(error, status) {
                try {

                    if (error.status == 401) {
                        app.showMessage("You have been logged out. Please login again to complete the operation.", "Error in Edit Operation", ["OK"], false, { buttonClass: "fa fa-times btn btn-default", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
                            .then(function (option) {
                                if (option == "OK")
                                    navigation.unauthorized();
                            })
                    }
                    else {
                        var msg = 'Exception: ' + error.statusText + ' | Source: ajaxFail in GetBusinessLevel() method in InherentRiskHeatMap.js';
                        logger.logMessage(msg);
                    }
                } catch (e) {
                    var msg = 'Exception: ' + e + ' | Source: ajaxFail in GetBusinessLevel() method in InherentRiskHeatMap.js';
                    logger.logMessage(msg);
                }
            }

        }
        function detached() {
            try {
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: detached() method in InherentRiskHeatMap.js';
                logger.logMessage(msg);
            }
        };

        //--------------------------------------------------------------------------Logic to Generate the Heat Map Starts----------------------------------------------------
        function BusinessLevelTabClick(data, event) {
            try {
                if (!HmViewModel.ComposeBindingFlag()) {
                    $('#expheatmapHm').show();
                    $('#exportDropdownBtnHm').show();
                    $('#LevelDropdown').show();
                }
                  

                else {
                    $('#exportDropdownBtnHm').hide();
                
                    
                }


                $('#expheatmap').show();
                $('#MainInherentHeatMapDiv').hide();
                HmViewModel.ClickedBusinessLevelId(data.BusinessLevelId());
                HmViewModel.ClickedBusinessLevelName(data.BusinessLevelName());
                if (HmViewModel.ClickedBusinessLevelName().indexOf('Inherent') !== -1) {
                    HmViewModel.ClickedBusinessLevelId(0);
                }

                //if (HmViewModel.ClickedBusinessLevelName().includes('Inherent')) {
                //    HmViewModel.ClickedBusinessLevelId(0);
                //}
                $('#error').hide();
                $('#loadingImgMainHm').modal('show');
                getHeatMapData();

            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: BusinessLevelTabClick() method in InherentRiskHeatMap.js';
                logger.logMessage(msg);
            }
        }
        function getHeatMapData() {
            try {
                $('#loadingImgMainHm').modal('show');
                $('#MainInherentHeatMapDiv').hide();
                if (HmViewModel.SelectedBUs() === undefined)
                    HmViewModel.SelectedBUs('');

                $.ajax({
                    url: "/api/HeatMap/GetHeatMapDataCRA",
                    type: "GET",
                    headers: appsecurity.getSecurityHeaders(),
                    data: {
                        AssessmentType: HmViewModel.AssessmentTypeId(),
                        LevelId: HmViewModel.ClickedBusinessLevelId(),
                        RiskType: HmViewModel.riskType(),
                        SelectedBUs: HmViewModel.SelectedBUs(),
                        SelectedLevel: HmViewModel.SelectedTaxonomyOption()
                    }
                })
                    .success(ajaxSuccess)
                    .fail(ajaxFail);
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source:ajax call in getHeatMapData() method in InherentRiskHeatMap.js';
                logger.logMessage(msg);
            }

            function ajaxSuccess(jsonResult) {
                try {         
                    if (HmViewModel.ComposeBindingFlag() != true) {
                        BindDynamicLevels();
                    }
                    $('#loadingImgMainHm').modal('hide');
                    HmViewModel.isAml(jsonResult.isAml);
                    if (jsonResult.businessUnitsModel.length === 0) {
                        $('#error').show();
                        $('#MainInherentHeatMapDiv').hide();
                        return;
                    }
                    else
                        if (jsonResult !== null){
                        $('#MainInherentHeatMapDiv').show();
                        $('#error').hide();
                        HmViewModel.AmlInhHeatMapData([]);
                        HmViewModel.InhRiskThemeDetails([]);
                        HmViewModel.AggregateBUDetails([]);
                        // Map Business Units.
                        if (jsonResult.businessUnitsModel.length > 0) {
                            var mappedBusinessUnitData = $.map(jsonResult.businessUnitsModel, function (result) {
                                return new BusinessUnitModel(result);
                            });
                            HmViewModel.AmlInhHeatMapData([]);
                            HmViewModel.AmlInhHeatMapDataDUP([]);
                            HmViewModel.AmlInhHeatMapData(mappedBusinessUnitData);
                            HmViewModel.AmlInhHeatMapDataDUP(mappedBusinessUnitData);

                        }
                        var mappedAggregateBUInformation = $.map(jsonResult.AggregateBUInformation, function (result) {
                            return new AggregateBUInformationModel(result);
                        });
                        HmViewModel.AggregateBUDetails(mappedAggregateBUInformation);
                        HmViewModel.AggregateBUDetailsDUP(mappedAggregateBUInformation);

                        if (HmViewModel.ClickedBusinessLevelId() == 0) {
                            if ($.fn.DataTable.isDataTable('#tblInhHeatMap')) {
                                var tableObj = $('#tblInhHeatMap').DataTable();
                                tableObj.fixedHeader.disable();
                                tableObj.destroy();
                                $('#tblInhHeatMap tbody tr').remove();
                                $("#InheatmapTr1 > th").remove();
                                $("#InheatmapTr2 > th").remove();
                                if (HmViewModel.ShowFinalData() == true) {
                                    $("#InheatmapTr3 > th").remove();
                                    $("#InheatmapTr4 > th").remove();
                                    $("#InheatmapTr5 > th").remove();
                                    $("#InheatmapTr6 > th").remove();
                                }

                                if (HmViewModel.isAml() == true) {
                                    HmViewModel.ColspanOrgLevel(1);
                                }
                                else
                                    HmViewModel.ColspanOrgLevel(3);

                                /* Row #    JS Bind String var      HTML div id     Data
                                 * 1        InheatmapTr1_jsBind     InheatmapTr1    BU Names
                                 * 2        InheatmapTr1_jsBind     InheatmapTr1    Overall Score
                                 * 3        InheatmapTr1_jsBind     InheatmapTr1    Calc Risk
                                 * 4        InheatmapTr1_jsBind     InheatmapTr1    Compliance Adjustment
                                 * 5        InheatmapTr1_jsBind     InheatmapTr1    Final Risk
                                 * 6        InheatmapTr1_jsBind     InheatmapTr1    Risk Type Header
                                */

                                //  The Dynamic Bind code for First and Sixth Row i.e. BU Names header and Risk Type header
                                var InheatmapTr1_jsBind = "";
                                var InheatmapTr6_jsBind = "";
                                InheatmapTr1_jsBind += '<th class="site_name label-info" ><i class="fa fa-arrow-down pl-3"></i> Areas / ' + HmViewModel.BUTitle() + '<i class="fa fa-arrow-right"></i> <span data-bind="html: $root.DataTableColumnWidth()"></span></th>'
                                InheatmapTr6_jsBind += '<th class="site_name label-info pl-3">Risk Type <i class="fa fa-arrow-right"></i></th>'
                                for (var i = 0; i < HmViewModel.AmlInhHeatMapData().length; i++) {
                                    InheatmapTr1_jsBind += '<th class="Heatmaplong text-center long header-ellipsis" colspan="' + HmViewModel.ColspanOrgLevel() + '" title= "' + HmViewModel.AmlInhHeatMapData()[i].BU_NAME() + ' data-bind="attr:{id: ' + HmViewModel.AmlInhHeatMapData()[i].BU_ID() + ', \'title\': ' + HmViewModel.AmlInhHeatMapData()[i].BU_NAME() + '}">' + HmViewModel.AmlInhHeatMapData()[i].BuName() + '</th>'
                                    if (HmViewModel.isAml() == false) {
                                        InheatmapTr6_jsBind += '<th class="Heatmaplong text-center" colspan="' + 1 + '" title="Internal Inherent Risk">Internal Inherent Risk</th>'
                                        InheatmapTr6_jsBind += '<th class="Heatmaplong text-center" colspan="' + 1 + '" title="External Inherent Risk">External Inherent Risk</th>'
                                    }
                                    InheatmapTr6_jsBind += '<th class="Heatmaplong text-center" colspan="' + 1 + '" title="Overall Inherent Risk">Overall Inherent Risk</th>'
                                }
                                $("#InheatmapTr1").append(InheatmapTr1_jsBind);
                                $("#InheatmapTr6").append(InheatmapTr6_jsBind);

                                if (HmViewModel.ShowFinalData() == true) {

                                    //  The Dynamic Bind code for Second, Third, Forth and Fifth Row
                                    var InheatmapTr2_jsBind = "";
                                    var InheatmapTr3_jsBind = "";
                                    var InheatmapTr4_jsBind = "";
                                    var InheatmapTr5_jsBind = "";
                                    InheatmapTr2_jsBind += '<th class="site_name label-info pl-3">Overall Calculated Score</th>'
                                    InheatmapTr3_jsBind += '<th class="site_name label-info pl-3">Calculated Level</th>'
                                    InheatmapTr4_jsBind += '<th class="site_name label-info pl-3">Qualitatively Adjusted Rating <i class="fa fa-info-circle" title="Click the corresponding cells to see qualitatively adjusted rating comments."></i></th>'
                                    InheatmapTr5_jsBind += '<th class="site_name label-info pl-3">Final Level</th>'
                                    for (var i = 0; i < HmViewModel.AggregateBUDetails().length; i++) {
                                        if (HmViewModel.isAml()) {
                                            InheatmapTr2_jsBind += '<th colspan="' + HmViewModel.ColspanOrgLevel() + '" class="threshold-cell text-center ' + HmViewModel.AggregateBUDetails()[i].RISK_CSS() + '" title= "' + HmViewModel.AggregateBUDetails()[i].RISK_SCORE() + '" data-bind="attr:{ \'title\': ' + HmViewModel.AggregateBUDetails()[i].RISK_SCORE() + '}">' + HmViewModel.AggregateBUDetails()[i].RISK_SCORE() + '</th>'
                                            InheatmapTr3_jsBind += '<th colspan="' + HmViewModel.ColspanOrgLevel() + '" class="threshold-cell text-center ' + HmViewModel.AggregateBUDetails()[i].CALC_CSS() + '" title= "' + HmViewModel.AggregateBUDetails()[i].CALC_LEVEL_ToolTip() + '" data-bind="attr:{ \'title\': ' + HmViewModel.AggregateBUDetails()[i].CALC_LEVEL_ToolTip() + '}">' + HmViewModel.AggregateBUDetails()[i].CALC_LEVEL_TEXT() + '</th>'
                                            InheatmapTr4_jsBind += '<th colspan="' + HmViewModel.ColspanOrgLevel() + '" class="threshold-cell text-center ' + HmViewModel.AggregateBUDetails()[i].COMPLIANCE_CSS() + '" title= "' + HmViewModel.AggregateBUDetails()[i].COMPLIANCE_LEVEL_ToolTip() + '" data-bind="attr:{ \'title\': ' + HmViewModel.AggregateBUDetails()[i].COMPLIANCE_LEVEL_ToolTip() + '}">' + HmViewModel.AggregateBUDetails()[i].COMPLIANCE_LEVEL_TEXT() + '</th>'
                                            InheatmapTr5_jsBind += '<th colspan="' + HmViewModel.ColspanOrgLevel() + '" class="threshold-cell text-center ' + HmViewModel.AggregateBUDetails()[i].FINAL_CSS() + '" title= "' + HmViewModel.AggregateBUDetails()[i].FINAL_LEVEL_ToolTip() + '" data-bind="attr:{ \'title\': ' + HmViewModel.AggregateBUDetails()[i].FINAL_LEVEL_ToolTip() + '}, css:{\'long header - ellipsis\': true}">' + HmViewModel.AggregateBUDetails()[i].FINAL_LEVEL_TEXT() + '</th>'
                                        }
                                        else {
                                            InheatmapTr2_jsBind += '<th colspan="' + HmViewModel.ColspanOrgLevel() + '" class="threshold-cell text-center ' + HmViewModel.AggregateBUDetails()[i].RISK_CSS() + '" title= "' + HmViewModel.AggregateBUDetails()[i].RISK_SCORE() + '" data-bind="attr:{ \'title\': ' + HmViewModel.AggregateBUDetails()[i].RISK_SCORE() + '}">' + HmViewModel.AggregateBUDetails()[i].RISK_SCORE() + '</th>'
                                            InheatmapTr3_jsBind += '<th colspan="' + HmViewModel.ColspanOrgLevel() + '" class="threshold-cell text-center ' + HmViewModel.AggregateBUDetails()[i].CALC_CSS() + '" title= "' + HmViewModel.AggregateBUDetails()[i].CALC_LEVEL_ToolTip() + '" data-bind="attr:{ \'title\': ' + HmViewModel.AggregateBUDetails()[i].CALC_LEVEL_ToolTip() + '}">' + HmViewModel.AggregateBUDetails()[i].CALC_LEVEL_TEXT() + '</th>'
                                            InheatmapTr4_jsBind += '<th colspan="' + HmViewModel.ColspanOrgLevel() + '" class="threshold-cell text-center ' + HmViewModel.AggregateBUDetails()[i].COMPLIANCE_CSS() + '" title= "' + HmViewModel.AggregateBUDetails()[i].COMPLIANCE_LEVEL_ToolTip() + '" data-bind="attr:{ \'title\': ' + HmViewModel.AggregateBUDetails()[i].COMPLIANCE_LEVEL_ToolTip() + '}">' + HmViewModel.AggregateBUDetails()[i].COMPLIANCE_LEVEL_TEXT() + '</th>'
                                            InheatmapTr5_jsBind += '<th colspan="' + HmViewModel.ColspanOrgLevel() + '" class="threshold-cell text-center ' + HmViewModel.AggregateBUDetails()[i].FINAL_CSS() + '" title= "' + HmViewModel.AggregateBUDetails()[i].FINAL_LEVEL_ToolTip() + '" data-bind="attr:{ \'title\': ' + HmViewModel.AggregateBUDetails()[i].FINAL_LEVEL_ToolTip() + '}, css:{\'long header - ellipsis\': true}">' + HmViewModel.AggregateBUDetails()[i].FINAL_LEVEL_TEXT() + '</th>'
                                        }
                                    }
                                    $("#InheatmapTr2").append(InheatmapTr2_jsBind);
                                    $("#InheatmapTr3").append(InheatmapTr3_jsBind);
                                    $("#InheatmapTr4").append(InheatmapTr4_jsBind);
                                    $("#InheatmapTr5").append(InheatmapTr5_jsBind);
                                }
                            }
                        } else {
                            if ($.fn.DataTable.isDataTable('#tblInhHeatMapOrg')) {
                                var tableObj = $('#tblInhHeatMapOrg').DataTable();
                                tableObj.fixedHeader.disable();
                                tableObj.destroy();
                                $('#tblInhHeatMapOrg tbody tr').remove();
                                $("#InheatmapOTr1 > th").remove();
                                $("#InheatmapOTr2 > th").remove();
                                if (HmViewModel.ShowFinalData() == true) {
                                    $("#InheatmapOTr3 > th").remove();
                                    $("#InheatmapOTr4 > th").remove();
                                    $("#InheatmapOTr5 > th").remove();
                                    $("#InheatmapOTr6 > th").remove();
                                }
                                var htmlHeaders1 = "";
                                var htmlHeaders2 = "";

                                htmlHeaders1 += '<th class="site_name label-info pl-3" > <i class="fa fa-arrow-down"></i> Areas /  ' + HmViewModel.BUTitle() +' <i class="fa fa-arrow-right"></i> <span data-bind="html: $root.DataTableColumnWidth()"></span></th>'
                                htmlHeaders2 += '<th class="site_name label-info pl-3">Risk Type <i class="fa fa-arrow-right"></i></th>'
                                for (var i = 0; i < HmViewModel.AmlInhHeatMapData().length; i++) {
                                    htmlHeaders1 += '<th class="Heatmaplong text-center" title= "' + HmViewModel.AmlInhHeatMapData()[i].BU_NAME() + '" data-bind="attr:{id: ' + HmViewModel.AmlInhHeatMapData()[i].BU_ID() + ', \'title\': ' + HmViewModel.AmlInhHeatMapData()[i].BU_NAME() + '}, css:{\'long header - ellipsis\': true}">' + HmViewModel.AmlInhHeatMapData()[i].BuName() + '</th>'
                                    htmlHeaders2 += '<th class="Heatmaplong text-center" colspan="1" title="Overall Inherent Risk">Overall Inherent Risk</th>'
                                }
                                $("#InheatmapOTr1").append(htmlHeaders1);
                                $("#InheatmapOTr2").append(htmlHeaders2);

                                if (HmViewModel.ShowFinalData() == true) {

                                    var htmlHeaders3 = "";
                                    var htmlHeaders4 = "";
                                    var htmlHeaders5 = "";
                                    var htmlHeaders6 = "";
                                    htmlHeaders3 += '<th class="site_name label-info pl-3">Overall Calculated Score</th>'
                                    htmlHeaders4 += '<th class="site_name label-info pl-3">Calculated Level</th>'
                                    htmlHeaders5 += '<th class="site_name label-info pl-3">Qualitatively Adjusted Rating <i class="fa fa-info-circle" title="Click the corresponding cells to see qualitatively adjusted rating comments."></i></th>'
                                    htmlHeaders6 += '<th class="site_name label-info pl-3">Final Level</th>'
                                    for (var i = 0; i < HmViewModel.AggregateBUDetails().length; i++) {
                                        htmlHeaders3 += '<th class="threshold-cell text-center long header-ellipsis ' + HmViewModel.AggregateBUDetails()[i].RISK_CSS() + '" title= "' + HmViewModel.AggregateBUDetails()[i].RISK_SCORE() + '" data-bind="attr:{ \'title\': ' + HmViewModel.AggregateBUDetails()[i].RISK_SCORE() + '}">' + HmViewModel.AggregateBUDetails()[i].RISK_SCORE() + '</th>'
                                        htmlHeaders4 += '<th class="threshold-cell text-center long header-ellipsis ' + HmViewModel.AggregateBUDetails()[i].CALC_CSS() + '" title= "' + HmViewModel.AggregateBUDetails()[i].CALC_LEVEL_ToolTip() + '" data-bind="attr:{ \'title\': ' + HmViewModel.AggregateBUDetails()[i].CALC_LEVEL_ToolTip() + '}">' + HmViewModel.AggregateBUDetails()[i].CALC_LEVEL_TEXT() + '</th>'
                                        htmlHeaders5 += '<th class="threshold-cell text-center long header-ellipsis ' + HmViewModel.AggregateBUDetails()[i].COMPLIANCE_CSS() + '" title= "' + HmViewModel.AggregateBUDetails()[i].COMPLIANCE_LEVEL_ToolTip() + '" data-bind="attr:{ \'title\': ' + HmViewModel.AggregateBUDetails()[i].COMPLIANCE_LEVEL_ToolTip() + '}">' + HmViewModel.AggregateBUDetails()[i].COMPLIANCE_LEVEL_TEXT() + '</th>'
                                        htmlHeaders6 += '<th class="threshold-cell text-center long header-ellipsis ' + HmViewModel.AggregateBUDetails()[i].FINAL_CSS() + '" title= "' + HmViewModel.AggregateBUDetails()[i].FINAL_LEVEL_ToolTip() + '" data-bind="attr:{ \'title\': ' + HmViewModel.AggregateBUDetails()[i].FINAL_LEVEL_ToolTip() + '}">' + HmViewModel.AggregateBUDetails()[i].FINAL_LEVEL_TEXT() + '</th>'
                                    }
                                    $("#InheatmapOTr3").append(htmlHeaders3);
                                    $("#InheatmapOTr4").append(htmlHeaders4);
                                    $("#InheatmapOTr5").append(htmlHeaders5);
                                    $("#InheatmapOTr6").append(htmlHeaders6);
                                }
                            }
                        }
                        HmViewModel.SubFactorGridDataList([]);
                        if (jsonResult.HeatmapSFGModel.length > 0) {
                            HmViewModel.SubFactorGridDataList(jsonResult.HeatmapSFGModel);
                        }

                        //Map Calculated Overide and Final Risk Levels for each BU
                        if (HmViewModel.ClickedBusinessLevelId() == 0) {
                            var oTable = $('#tblInhHeatMap').DataTable(
                                {
                                    'aoColumnDefs': [{
                                        'bSortable': false,
                                        "targets": "_all"
                                    }],
                                    "aaSorting": [],
                                    scrollY: "47rem",
                                    scrollX: true,
                                    scrollCollapse: true,
                                    paging: false,
                                    bFilter: true,
                                    "bInfo": false,
                                    fixedColumns: true,
                                    fixedheader: {
                                        header: true
                                    },
                                    autoWidth: true
                                }).draw();
                        } else {
                            var oTable1 = $('#tblInhHeatMapOrg').DataTable(
                                {
                                    'aoColumnDefs': [{
                                        'bSortable': false,
                                        "targets": "_all"
                                    }],
                                    "aaSorting": [],
                                    scrollY: "47rem",
                                    scrollX: true,
                                    scrollCollapse: true,
                                    paging: false,
                                    bFilter: true,
                                    "bInfo": false,
                                    fixedColumns: {
                                        leftColumns: 1
                                    },
                                    fixedheader: {
                                        header: true,
                                    }
                                }).draw();
                        }
                    }
                    else {
                        $('#expheatmap').hide();
                        $('#expheatmapHm').hide();
                        $('#error').show();
                        $('#innerdiv').hide();
                    }

                    if (HmViewModel.IsSideNavOpen() == 1) {
                        document.getElementById("sideNavHm").style.height = "26%";
                    }
                    if (HmViewModel.NumberOfBUsSelected() == 0) {
                        $('.badge').css({ 'display': 'none' });
                    }
                }
                catch (e) {
                    var msg = 'Exception: ' + e + ' | Source:ajaxSuccess in getHeatMapData() method in InherentRiskHeatMap.js';
                    logger.logMessage(msg);
                }
            }

            function ajaxFail(error, status) {
                try {

                    if (error.status == 401) {
                        app.showMessage("You have been logged out. Please login again to complete the operation.", "Error in Edit Operation", ["OK"], false, { buttonClass: "fa fa-times btn btn-default", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
                            .then(function (option) {
                                if (option == "OK")
                                    navigation.unauthorized();

                            })
                    }
                    else {
                        var msg = 'Exception: ' + error.statusText + ' | Source: ajaxFail in getHeatMapData() method in InherentRiskHeatMap.js';
                        logger.logMessage(msg);
                    }
                } catch (e) {
                    var msg = 'Exception: ' + e + ' | Source: ajaxFail in getHeatMapData() method in InherentRiskHeatMap.js';
                    logger.logMessage(msg);
                }
            }
        }

        //--------------------------------------------------------------------------Logic to Generate the Heat Map Ends----------------------------------------------------

        //--------------------------------------------------------------------------Logic For Exporting Heatmaps to Excel using SSRSS, Expand Collapse functionality starts Here-------------------------------------------------------

        function NavigateToSSRSExportReport() {
            try {
                $('#loadingImgMainHm').modal('show');
                var payLoad = {
                    t: appsecurity.getAuthenticationInfo(), AssessmentType: HmViewModel.AssessmentTypeId(), OrgLevel: HmViewModel.ClickedBusinessLevelId(), SourceName: HmViewModel.SourceName()
                };
                utils.postAndRedirect(rootPath + "/FileDownload/ExportHeatmapResults", payLoad, '_blank');
                $('#loadingImgMainHm').modal('hide');
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: NavigateToSSRSExportReport() method in InherentRiskHeatMap.js';
                logger.logMessage(msg);
            }
        }

        //--------------------------------------------------------------------------Logic For Exporting Heatmaps to Excel using SSRSS ends Here-------------------------------------------------------

        //---------------------------------------------------------------------------Model Definition Starts Here-------------------------------------------------------------------
        function BusinessUnitModel(item) {
            try {
                var self = this;
                self.BU_ID = ko.observable(item.BU_ID);
                self.BU_NAME = ko.observable($('<div/>').html(item.BU_NAME).text());
                self.BusinessUnitId = ko.observable($('<div/>').html(item.BuId).text());
                self.BusinessUnitName = ko.observable($('<div/>').html(item.BuName).text());
                var value = item.BU_NAME
                var buVal = "";
                if (item.BU_NAME === undefined) {
                    buVal = item.BuName;
                } else {
                    buVal = item.BU_NAME;
                }
                if (buVal != undefined && buVal.length > 50) {
                    value = buVal.substring(0, 50) + '...';
                } else {
                    var space = buVal.length;
                    var spaceText = '';
                    for (j = 0; j < 5 - space; j++) {
                        spaceText += '&nbsp';
                    }
                    value = spaceText + buVal + spaceText;
                }
                self.BuName = ko.observable($('<div/>').html(value).text());

                self.AssessmentDate = ko.observable($('<div/>').html(item.BuAssessmentDate).text());
                self.BuStatus = ko.observable($('<div/>').html(item.BuStatus).text());
                self.SubLevelId = ko.observable(item.SubLevelId);
                self.isChecked = ko.observable(false);
                if (item.FINAL_Flag != undefined) {
                    self.ShowFinalData = ko.observable(item.FINAL_Flag);
                    HmViewModel.ShowFinalData(item.FINAL_Flag);
                } else
                    HmViewModel.ShowFinalData(false);
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: BusinessUnitModel() in InherentRiskHeatMap.js';
                logger.logMessage(msg);
            }
        }

        function BusinessLevelsModel(item) {
            try {
                var self = this;
                self.Bulevel = ko.observable($('<div/>').html(item.Bulevel).text());
                self.BlName = ko.observable($('<div/>').html(item.BlName).text());
                self.BlId = ko.observable(item.BlId)
                var MappedBuLevelValueList = $.map(item.BuLevelValueList, function (result) {
                    return new BuLevelValueListModel(result);
                });
                self.BusinessLevelValueList = ko.observableArray(MappedBuLevelValueList);
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: BusinessLevelsModel() in InherentRiskHeatMap.js';
                logger.logMessage(msg);
            }
        }

        function BusinessLevelModel(item) {
            try {
                var self = this;
                self.BusinessLevelId = ko.observable($('<div/>').html(item.BuLId).text());
                self.BusinessLevelName = ko.observable($('<div/>').html(item.BuLevelName).text());

            } catch (e) {
                var msg = 'Exception: ' + e + ' | Source: BusinessLevelModel() in InherentRiskHeatMap.js';
                logger.logMessage(msg);
            }
        }

        function BusinessUnitModelDUP(item) {
            try {
                var self = this;
                self.BusinessUnitId = ko.observable($('<div/>').html(item.BusinessUnitId()).text());
                self.BU_ID = ko.observable($('<div/>').html(item.BusinessUnitId()).text());
                self.BuId = ko.observable($('<div/>').html(item.BusinessUnitId()).text());
                self.BusinessUnitName = ko.observable($('<div/>').html(item.BusinessUnitName()).text());
                self.BuName = ko.observable($('<div/>').html(item.BusinessUnitName()).text());
                self.BU_NAME = ko.observable($('<div/>').html(item.BusinessUnitName()).text());
                self.AssessmentDate = ko.observable($('<div/>').html(item.AssessmentDate()).text());
                self.BuStatus = ko.observable($('<div/>').html(item.BuStatus()).text());
                self.SubLevelId = ko.observable(item.SubLevelId());
                self.isChecked = ko.observable(false);
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: BusinessUnitModel() method in InherentRiskHeatMap.js';
                logger.logMessage(msg);
            }
        }

        function OverrideCommentModel(item) {
            try {
                var self = this;
                self.CommentId = ko.observable(item.CommentId);
                self.CommentText = ko.observable($('<div/>').html(item.CommentText).text());
                self.UploadedBy = ko.observable($('<div/>').html(item.UploadedBy).text());
                self.UploadRole = ko.observable($('<div/>').html(item.UploadRole).text());
                self.UploadedDate = ko.observable($('<div/>').html(item.UploadedDate).text());
                self.FullName = ko.computed(function () {
                    return item.UploadedBy + " (" + $('<div/>').html(item.UploadRole).text() + ")";
                });
            }
            catch (e) {
                var msg = 'exception' + e + 'source: OverrideCommentModel() in InherentRiskHeatMap.js';
                logger.logMessage(msg);
            }
        }
        function AggregateBUInformationModel(item) {
            var self = this;
            self.BU_ID = ko.observable(item.BU_ID);
            self.BU_NAME = ko.observable(item.BU_NAME);
            self.CALC_ID = ko.observable(item.CALC_ID);
            self.CALC_CSS = ko.observable(item.CALC_CSS);
            var trimmedCALC_Level = item.CALC_LEVEL;
            if (trimmedCALC_Level.length > 21)
                trimmedCALC_Level = trimmedCALC_Level.substring(0, 18) + '...';
            else
                trimmedCALC_Level = trimmedCALC_Level;

            self.CALC_LEVEL_TEXT = ko.observable(trimmedCALC_Level);
            self.CALC_LEVEL_ToolTip = ko.observable(item.CALC_LEVEL);
            self.CALC_LEVEL = ko.observable(item.CALC_LEVEL);
            self.COMPLIANCE_ID = ko.observable(item.COMPLIANCE_ID);
            var CompLevel = item.COMPLIANCE_LEVEL;
            if (CompLevel.length > 21)
                CompLevel = CompLevel.substring(0, 18) + '...';
            else
                CompLevel = CompLevel;

            self.COMPLIANCE_LEVEL_TEXT = ko.observable(CompLevel);
            self.COMPLIANCE_LEVEL_ToolTip = ko.observable(item.COMPLIANCE_LEVEL);
            self.COMPLIANCE_LEVEL = ko.observable(item.COMPLIANCE_LEVEL);
            self.COMPLIANCE_CSS = ko.observable(item.COMPLIANCE_CSS);
            self.FINAL_ID = ko.observable(item.FINAL_ID);
            var trimmedLevel = item.FINAL_LEVEL;
            if (trimmedLevel.length > 21)
                trimmedLevel = trimmedLevel.substring(0, 18) + '...';
            else
                trimmedLevel = trimmedLevel;

            self.FINAL_LEVEL_TEXT = ko.observable(trimmedLevel);
            self.FINAL_LEVEL_ToolTip = ko.observable(item.FINAL_LEVEL);
            self.FINAL_LEVEL = ko.observable(item.FINAL_LEVEL);
            self.FINAL_CSS = ko.observable(item.FINAL_CSS);
            self.RISK_CSS = ko.observable(item.RISK_CSS);
            self.RISK_SCORE = ko.observable(item.RISK_SCORE);
            self.OLD_SELECTED_DROPDOWN = ko.observable();
            self.SELECTED_DROPDOWN = ko.observable();
            self.OverrideCommentsList = ko.observable();
            self.ClickShowComments = function () {
                var ParamString = "BusinessUnitId=" + self.BU_ID() + "&RiskAreaId=0&RiskFactorId=0&TableType=INH&AssessmentType=" + HmViewModel.AssessmentType() + "&HeatMapType=INH&CommentType=B&ValueType=null&OrganizationalLevelID=" + HmViewModel.ClickedBusinessLevelId() + "&AssessmentTypeId=" + HmViewModel.AssessmentTypeId();
                $.ajax({
                    url: "/api/HeatMap/GetOverrideComment?" + ParamString,
                    type: "GET",
                    headers: appsecurity.getSecurityHeaders()
                })
                    .success(function (jsonResult, success) {
                        try {
                            if (jsonResult != null) {
                                var mappedOverrideCommentsList = $.map(jsonResult, function (result) {
                                    return new OverrideCommentModel(result);
                                });
                                HmViewModel.OverrideCommentsList([]);
                                HmViewModel.OverrideCommentsList(mappedOverrideCommentsList);
                                $('#ViewOverrideCommentsPopUp').modal('show');
                            }
                            else
                                logger.logError('Failed to load  qualitatively adjusted rating comments. Please try again.', 'Error', system.getModuleId(HmViewModel), true);
                        }
                        catch (e) {
                            var msg = 'Exception: ' + e + ' | Source: ajaxSuccess call in GetOverrideComments() method in InherentRiskHeatMap.js';
                            logger.logMessage(msg);
                        }
                    })
                    .fail(function (fail, error) {
                        logger.logError('Failed to load qualitatively adjusted rating comments. Please try again.', 'Error', system.getModuleId(HmViewModel), true);
                    });

            };
        }

        function GetTaxonomyList() {
            try {
                $.ajax({
                    url: "/api/HeatMap/GetTaxonomyList",
                    type: "GET",
                    headers: appsecurity.getSecurityHeaders(),
                    data: {
                        "PageType": 'HM',
                    },
                })
                    .success(ajaxSuccess)
                    .fail(ajaxFail);
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ajax call in GetTaxonomyList() method in ActionItemDetails.js';
                logger.logMessage(msg);
            }

            function ajaxSuccess(jsonResult, error) {
                try {
                    HmViewModel.TaxonomyLevelList([]);
                    if (jsonResult != null) {
                        var mappedList = $.map(jsonResult, function (result) {
                            return new TaxonomyModel(result);
                        });

                        HmViewModel.TaxonomyLevelList([]);
                        HmViewModel.TaxonomyLevelList(mappedList);

                        if (HmViewModel.TaxonomyLevelList() != undefined || HmViewModel.TaxonomyLevelList().length > 0)
                            HmViewModel.SelectedTaxonomyOptionText(HmViewModel.TaxonomyLevelList()[0].TaxonomyName())
                    }
                }
                catch (e) {
                    var msg = 'Exception: ' + e + ' | Source: ajaxSuccess in GetTaxonomyList() method in ActionPlanDetails.js';
                    logger.logMessage(msg);
                }
            }

            function ajaxFail(error, status) {
                try {
                    if (error.status == 401) {
                        app.showMessage("You have been logged out. Please login again to complete the operation.", "Error in Edit Operation", ["OK"], false, { buttonClass: "fa fa-times btn btn-default", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
                            .then(function (option) {
                                if (option == "OK")
                                    navigation.unauthorized();
                            })
                    }
                    else {
                        var msg = 'Exception: ' + error.statusText + ' | Source: ajaxFail in GetTaxonomyList() method in ActionPlanDetails.js';
                        logger.logMessage(msg);
                    }
                } catch (e) {
                    var msg = 'Exception: ' + e + ' | Source: ajaxFail in GetTaxonomyList() method in ActionPlanDetails.js';
                    logger.logMessage(msg);
                }
            };
        }

        function TaxonomyModel(item) {
            try {
                var self = this;
                self.TaxonomyId = ko.observable(item.TaxonomyId);
                self.TaxonomyName = ko.observable($('<div/>').html(item.TaxonomyName).text());
                self.LevelId = ko.observable($('<div/>').html(item.LevelId).text());
                self.LevelMapId = ko.observable($('<div/>').html(item.LevelMapId).text());
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: TaxonomyModel() method in ActionItemDetails.js';
                logger.logMessage(msg);
            }
        }

        function DisplayExportDropdown(data, event) {
            closeSideNav();
            $('#myValueDropdownLevel').removeClass('show');
            $('#myValueDropdownSortLevel').removeClass('open');

            document.getElementById("exportDropdownHm").classList.toggle("show");
            document.getElementById("exportDropdownBtnHm").classList.toggle("open");
        }

        function BindDynamicLevels() {
            try {
                var DynamicHtml = "";
                DynamicHtml = ' <div class="dropdown float-right" id="LevelDropdown">' +
                    '<button id="myValueDropdownSortLevel" data-bind="click: FormatValueDataLevel" class="dropbtn" title="Change the level" style="padding-right: 0.7rem;">Levels ' +
                    '<span class="mt-2" style="color: gray;"> - ' + HmViewModel.SelectedTaxonomyOptionText() + '</span> <span class="fa fa-chevron-down" style="margin-left: 4px;"></span>' +
                    '<div id="myValueDropdownLevel" class="dropdown-content" style="min-width:11rem; margin-left: -0.5rem;">';
                for (var i = 0; i < HmViewModel.TaxonomyLevelList().length; i++) {
                    DynamicHtml += '<a href="#" id="' + HmViewModel.TaxonomyLevelList()[i].LevelMapId().replace(/\s/g, '') + '" data-bind="click: $root.valuechangeLevel"><i class="fa fa-check" id="' + HmViewModel.TaxonomyLevelList()[i].TaxonomyName().replace(/\s/g, '') + 'TL" aria-hidden="true" style="display:none;margin-left: -1.1rem;margin-top: 3px;"></i><span style="margin-left:8px;">' + HmViewModel.TaxonomyLevelList()[i].TaxonomyName() + '</span></a>';
                }
                '</div></div>';

                $('#LevelsDivHm').html("");
                $('#LevelsDivHm').html(DynamicHtml);

                var element = $('#LevelsDivHm')[0];
                ko.cleanNode(element);
                ko.applyBindings(HmViewModel, document.getElementById('LevelsDivHm'));
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: BindDynamicLevels() method in InherentRiskHeatMap.js';
                logger.logMessage(msg);
            }
        }

        function FormatValueDataLevel(data, event) {
            $('#myValueDropdown').removeClass('show');
            $('#myValueDropdownSort').removeClass('open');
            $('#myDropdown').removeClass('show');
            $('#myDropdownSort').removeClass('open');
            $('#exportDropdownHm').removeClass('show');
            $('#exportDropdownBtnHm').removeClass('open');
            
            document.getElementById("myValueDropdownLevel").classList.toggle("show");
            document.getElementById("myValueDropdownSortLevel").classList.toggle("open");
        }

        function valuechangeLevel(data, event) {
            try {
                var optionId = event.currentTarget.id;
                if (event.currentTarget.firstElementChild.style.display === "none") {
                    event.currentTarget.firstElementChild.style.display = "inline-block"
                }
                else {
                    event.currentTarget.firstElementChild.style.display = "none";
                }
                HmViewModel.SelectedTaxonomyOptionText(event.currentTarget.innerText);
                HmViewModel.SelectedTaxonomyOption(optionId);
                getHeatMapData();
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: valuechange() method in InherentRiskHeatMap.js';
                logger.logMessage(msg);
            }
        }


        //---------------------------------------------------------------------------Model Definition Ends Here---------------------------------------------------------------------//
    });

